// src/lib/partner/partnerInvitationCapacity.js

import { supabase } from "../../supabaseClient";


export async function fetchPartnerCohortInvitationCapacity(
  cohortId
) {
  const cleanCohortId =
    String(
      cohortId || ""
    ).trim();

  if (!cleanCohortId) {
    throw new Error(
      "A cohort is required."
    );
  }

  const {
    data,
    error,
  } = await supabase.rpc(
    "get_partner_cohort_invitation_capacity",
    {
      p_cohort_id:
        cleanCohortId,
    }
  );

  if (error) {
    throw error;
  }

  return data || null;
}